import { Text } from '@mantine/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20vh;
`;

export const Emoji = styled.div`
  font-size: 60px;
`;

export const Message = styled(Text)`
  font-size: 24px;
  font-weight: 200;
`;

export const Description = styled(Text)`
  margin-top: 20px;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.7);
`;
